import { NoticeProxy } from "@service/components/notice-hub/helpers/NoticeProxy";
import { Notice } from "@service/components/toast/type/Notice";
import {ActionTree} from "@service/store/types/Store";
import { GroupedNoticeParams, NoticeState } from "../types/NoticeState";
import {RootState} from "../types/RootState";

export const noticeActions = {
    submitNotice: "notice/submitNotice",
    submitGroupedNotice: "notice/submitGroupedNotice",
    removeGroup: "notice/removeGroup",
    clearQueue: "notice/clearQueue",
    setProxy: "notice/setProxy"
} as const;

export const actions: ActionTree<NoticeState, RootState, typeof noticeActions> = {
    submitNotice({ state }, payload: Notice) {
        state.queue.push(payload);
    },

    submitGroupedNotice({ state, commit }, payload: GroupedNoticeParams) {
        if (Object.prototype.hasOwnProperty.call(state.groups, payload.groupId)) {
            commit("updateGroup", payload)
        }
        else {
            commit("initGroup", payload)
        }

        //selecting last message if there is many
        const message = payload.data[payload.data.length - 1];

        state.queue.push(message)
    },

    removeGroup({ commit }, groupId: string) {
        commit("removeGroup", groupId)
    },

    setProxy({ commit }, payload: NoticeProxy) {
        commit("setProxy", payload)
    },

    clearQueue({ commit }) {
        commit("setQueue", [])
    }
};